<ul class="nav">
  <li class="nav-item" [ngClass]="{ active: activeTab == '1800late' }">
    <a
      class="nav-link paragraph-regular-16 Display-family Text-100"
      href="javascript:void(0)"
      (click)="filterSlider('late', 1800)"
      >Late 1800s</a
    >
  </li>
  <li class="nav-item" [ngClass]="{ active: activeTab == '1920early' }">
    <a
      class="nav-link paragraph-regular-16 Display-family Text-100"
      href="javascript:void(0)"
      (click)="filterSlider('early', 1920)"
      >Early 1900s</a
    >
  </li>
  <!-- <li class="nav-item" [ngClass]="{ active: activeTab == '1900mid' }">
    <a
      class="nav-link paragraph-regular-16 Display-family Text-100"
      href="javascript:void(0)"
      (click)="filterSlider('mid', 1900)"
      >Mid 1900s</a
    >
  </li> -->
  <li class="nav-item" [ngClass]="{ active: activeTab == '1900late' }">
    <a
      class="nav-link paragraph-regular-16 Display-family Text-100"
      href="javascript:void(0)"
      (click)="filterSlider('late', 1900)"
      >Late 1900s</a
    >
  </li>
  <li class="nav-item" [ngClass]="{ active: activeTab == '2000early' }">
    <a
      class="nav-link paragraph-regular-16 Display-family Text-100"
      href="javascript:void(0)"
      (click)="filterSlider('early', 2000)"
      >Early 2000s</a
    >
  </li>
</ul>

<div class="owl-container"  [ngClass]="{'rm-defaultNav': removeDefaultNav}">
  <!-- <svg class="fade-shadow" width="124" height="485" viewBox="0 0 124 485" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="124" height="485" fill="url(#paint0_linear_481_8169)" fill-opacity="0.9"/>
    <defs>
    <linearGradient id="paint0_linear_481_8169" x1="120.457" y1="197.829" x2="0.0341212" y2="195.617" gradientUnits="userSpaceOnUse">
    <stop stop-color="white"/>
    <stop offset="1" stop-color="white" stop-opacity="0"/>
    </linearGradient>
    </defs>
    </svg> -->
  <owl-carousel-o
    #owlCar
    [options]="customOptions"
    (change)="getPassedData($event)"
  >
    <ng-container *ngFor="let slide of sliderData; let i = index">
      <ng-template carouselSlide [id]="'owl-slide-'+slide?.id">
        <div class="slider-column">
          <div class="slider-image">
            <img [src]="slide.image" alt="img 3" />
          </div>
          <h3 class="Display-family heading-bold-28 Text-100">
            <span>{{ slide?.name }}</span>
          </h3>
          <p class="paragraph-regular-16 Text-100">
            {{ slide?.text }}
          </p>
          <a
            *ngIf="slide?.showBtn"
            (click)="readMore(slide?.name)"
            href="javascript:void(0)"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            class="paragraph-semibold-14 Text-10"
            >Read More</a
          >
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>

<!-- -------------------------------------------------popup----------------------------- -->

<div
  class="modal fade olds-carousel"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title Display-family heading-bold-36"
          id="exampleModalLabel"
        >
          {{ popupData[popupDataIndex]?.name }}
        </h5>
        <button
          type="button"
          class="cross-icon"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="27.5"
              y="27.5"
              width="27"
              height="27"
              rx="7.5"
              transform="rotate(-180 27.5 27.5)"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.43414 9.43427C9.74656 9.12185 10.2531 9.12185 10.5655 9.43427L13.9998 12.8686L17.4341 9.43427C17.7466 9.12185 18.2531 9.12185 18.5655 9.43427C18.8779 9.74669 18.8779 10.2532 18.5655 10.5656L15.1312 14L18.5655 17.4343C18.8779 17.7467 18.8779 18.2532 18.5655 18.5656C18.2531 18.8781 17.7466 18.8781 17.4341 18.5656L13.9998 15.1313L10.5655 18.5656C10.2531 18.8781 9.74656 18.8781 9.43414 18.5656C9.12172 18.2532 9.12172 17.7467 9.43414 17.4343L12.8685 14L9.43414 10.5656C9.12172 10.2532 9.12172 9.74669 9.43414 9.43427Z"
              fill="#0B203E"
            />
            <rect
              x="27.5"
              y="27.5"
              width="27"
              height="27"
              rx="7.5"
              transform="rotate(-180 27.5 27.5)"
              stroke="#0B203E"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <img
          [src]="popupData[popupDataIndex]?.popupImage"
          alt="{{ popupData[popupDataIndex]?.name }}"
        />
        <p class="body-text paragraph-regular-16">
          {{ popupData[popupDataIndex]?.popupText }}
        </p>
      </div>
      <div class="modal-footer">
        <ng-container *ngIf="popupData?.length > 1">
          <button
            [disabled]="leftBtnDisable"
            type="button"
            class="btn"
            (click)="leftPopUpDetail('left')"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="32.0234"
                y="31.3799"
                width="31.5238"
                height="30.8798"
                rx="7.5"
                transform="rotate(-180 32.0234 31.3799)"
                fill="white"
              />
              <path
                d="M13.3575 17.2471L16.0455 20.2471C16.3575 20.6071 16.3335 21.1831 15.9495 21.5191C15.5895 21.8311 15.0135 21.8071 14.7015 21.4231L10.6935 16.9351C10.3815 16.5751 10.3815 16.0711 10.6935 15.7351L14.7015 11.2471C15.0135 10.8631 15.5895 10.8391 15.9495 11.1751C16.3335 11.4871 16.3575 12.0631 16.0455 12.4231L13.3575 15.4471L21.3735 15.4471C21.8535 15.4471 22.2615 15.8311 22.2615 16.3351C22.2615 16.8391 21.8535 17.2471 21.3735 17.2471L13.3575 17.2471Z"
                fill="#0B203E"
              />
              <rect
                x="32.0234"
                y="31.3799"
                width="31.5238"
                height="30.8798"
                rx="7.5"
                transform="rotate(-180 32.0234 31.3799)"
                stroke="#0B203E"
              />
            </svg>
          </button>
          <button
            [disabled]="rightBtnDisable"
            type="button"
            class="btn"
            (click)="leftPopUpDetail('right')"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="32.0234"
                y="31.3799"
                width="31.5238"
                height="30.8798"
                rx="7.5"
                transform="rotate(-180 32.0234 31.3799)"
                fill="white"
              />
              <path
                d="M19.1655 14.6328L16.4775 11.6328C16.1655 11.2728 16.1895 10.6968 16.5735 10.3608C16.9335 10.0488 17.5095 10.0728 17.8215 10.4568L21.8295 14.9448C22.1415 15.3048 22.1415 15.8088 21.8295 16.1448L17.8215 20.6327C17.5095 21.0167 16.9335 21.0407 16.5735 20.7047C16.1895 20.3927 16.1655 19.8167 16.4775 19.4567L19.1655 16.4328L11.1495 16.4328C10.6695 16.4328 10.2615 16.0488 10.2615 15.5448C10.2615 15.0408 10.6695 14.6328 11.1495 14.6328L19.1655 14.6328Z"
                fill="#0B203E"
              />
              <rect
                x="32.0234"
                y="31.3799"
                width="31.5238"
                height="30.8798"
                rx="7.5"
                transform="rotate(-180 32.0234 31.3799)"
                stroke="#0B203E"
              />
            </svg>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
